import { getFormattedDateTimeFromTimestamp } from '../../../utilities/commonFunctions';
import { SOS_CALL_TYPES, SOS_TYPES } from '../../../utilities/constants';

const createBaseColumn = (title, dataIndex, options = {}) => ({
  title,
  dataIndex,
  key: dataIndex,
  ellipsis: true,
  sort: true,
  filter: true,
  ...options,
});

const createDateColumn = (title, dataIndex) => ({
  ...createBaseColumn(title, dataIndex),
  render: date => getFormattedDateTimeFromTimestamp(date),
  filter: false,
});

export const commonColumns = {
  messageid: createBaseColumn('Message ID', 'messageid'),
  trip_id: createBaseColumn('Trip ID', 'trip_id'),
  device_id: createBaseColumn('Device ID', 'device_id'),
  timestamp: createDateColumn('Timestamp', 'timestamp'),
  sos_type: createBaseColumn('SOS Type', 'sos_type', {
    filter: false,
    selectFilter: true,
    selectFilterOptions: Object.entries(SOS_TYPES)?.map(([, value]) => ({
      label: value,
      value: value,
    })),
  }),
  reporter: createBaseColumn('Reporter', 'reporter'),
  call_type: createBaseColumn('Call Type', 'call_type', {
    filter: false,
    selectFilter: true,
    selectFilterOptions: Object.entries(SOS_CALL_TYPES)?.map(([, value]) => ({
      label: value,
      value: value,
    })),
  }),
  assigned_to: createBaseColumn('Assigned To', 'assigned_to'),
  so_ticket_id: createBaseColumn('SO Ticket ID', 'so_ticket_id'),
  drivername: createBaseColumn('Driver Name', 'drivername'),
  driver_number: createBaseColumn('Driver Number', 'driver_number'),
  description: createBaseColumn('Description', 'description', {
    ellipsis: false,
    render: text => (
      <div className="ant-table-cell-wrap description-cell">{text}</div>
    ),
  }),
  comments: createBaseColumn('Comments', 'comments'),
  resolved_by: createBaseColumn('Resolved By', 'resolved_by'),
  vehicle_number: createBaseColumn('Vehicle Number', 'vehicle_number'),
  cab_registration: createBaseColumn('Cab Registration', 'cab_registration'),
  anomaly_type: createBaseColumn('Anomaly Type', 'anomaly_type'),
  driver_name: createBaseColumn('Driver Name', 'driver_name'),
  phone_number: createBaseColumn('Phone Number', 'phone_number'),
  total_passengers: createBaseColumn('Total Passengers', 'total_passengers'),
  time_start: createDateColumn('Trip Start', 'time_start'),
  time_end: createDateColumn('Trip End', 'time_end'),
  revised_anomaly_type: createBaseColumn(
    'Event Status',
    'revised_anomaly_type'
  ),
  comment: createBaseColumn('Comment', 'comment'),
  action_taken_by: createBaseColumn('Action Taken By', 'action_taken_by'),
  action_timestamp: createDateColumn('Action Timestamp', 'action_timestamp'),
  sticker_id: createBaseColumn('Sticker ID', 'sticker_id'),
};

export const getSOSLogsColumns = () => [
  // commonColumns.messageid,
  commonColumns.trip_id,
  commonColumns.device_id,
  commonColumns.cab_registration,
  commonColumns.timestamp,
  commonColumns.call_type,
  commonColumns.sos_type,
  commonColumns.reporter,
  commonColumns.assigned_to,
];

export const getSOSLogsExpandedColumns = () => [
  commonColumns.so_ticket_id,
  commonColumns.drivername,
  commonColumns.description,
  commonColumns.comments,
  commonColumns.resolved_by,
];

export const getDriverDrowsinessLogsColumns = () => [
  commonColumns.trip_id,
  commonColumns.device_id,
  commonColumns.vehicle_number,
  // { ...commonColumns.anomaly_type, filter: false },
  commonColumns.driver_name,
  commonColumns.revised_anomaly_type,
  commonColumns.timestamp,
  commonColumns.comment,
  commonColumns.action_taken_by,
  commonColumns.action_timestamp,
  // commonColumns.phone_number,
];

export const getAnomalyLogsColumns = () => [
  commonColumns.trip_id,
  commonColumns.sticker_id,
  commonColumns.device_id,
  commonColumns.vehicle_number,
  commonColumns.timestamp,
  commonColumns.driver_name,
  commonColumns.total_passengers,
];

export const getVideoOnDemandLogsColumns = () => [
  commonColumns.trip_id,
  commonColumns.vehicle_number,
  commonColumns.device_id,
  commonColumns.timestamp,
];
